export class CatalogoProducto {
    n?:string;
    id?:string;
    nombre?:string;
    codigo?:string;
    constructor(){}
}

